interface ScrollShadowParameters {
  /**
   * The direction of the scrollShadow's linear gradient. If the element containing the scrollShadow is on top and the shadow is fading down it should be set to "down".
   * If it is on the bottom and the shadow is fading up, it should be set to "up".
   */
  direction: 'down' | 'up'
  /**
   * The height of the scrollShadow's linear gradient.
   */
  height: string
  /**
   *  The start color of the css scrollShadow's linear-gradient.
   */
  shadowColorStart: string
  /**
   *  The end color of the css scrollShadow's linear-gradient.
   */
  shadowColorEnd: string
}

/**
 * Adds a css linear-gradient scroll-shadow to an element.
 *
 * @return a pseudo element with a scrollShadow positioned absolutely.
 */
export function scrollShadow({
  direction,
  height,
  shadowColorStart,
  shadowColorEnd,
}: ScrollShadowParameters) {
  const scrollShadowStyles = {
    display: 'block',
    position: 'relative',

    '&::before': {
      backgroundImage: `linear-gradient(0deg,
        ${direction === 'down' ? shadowColorStart : shadowColorEnd},
        ${direction === 'down' ? shadowColorEnd : shadowColorStart})`,
      bottom: direction === 'down' ? `-${height}` : '0px',
      content: '""',
      display: 'block',
      height,
      position: 'absolute',
      width: '100%',
    },
  } as const

  return scrollShadowStyles
}
